import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { usePermissoes } from '../contexts/PermissoesContext';
import BotaoMenuMobile from '../components/common/BotaoMenuMobile';
import SeletorOrganizacao from '../components/common/SeletorOrganizacao';
import Relatorios from './Relatorios';
import s from './RelatoriosMobile.module.css';
import { BRAND_MARCA_CURTA } from '../brand';

/**
 * Versão simplificada pra acesso pelo celular (sem sidebar/abas do app
 * desktop) — reaproveita 100% da lógica/telas de Relatorios.jsx, só
 * envolvendo num cabeçalho enxuto. Ver hooks/useIsMobile.js e App.jsx
 * (rota /relatorios-mobile é pra onde o celular é redirecionado sempre
 * que tenta abrir qualquer outra tela do sistema).
 */
export default function RelatoriosMobile() {
  const { usuario, logout } = useAuth();
  const { pronto, permitido } = usePermissoes();
  const podeTrocarOrg = ['admin', 'gerente'].includes((usuario?.perfil || '').toLowerCase());

  if (!pronto) return null;

  if (!permitido('/relatorios')) {
    return (
      <div className={s.semAcesso}>
        <p>Seu usuário não tem permissão de acesso a Relatórios.</p>
        <button className={s.sair} onClick={logout}>Sair</button>
      </div>
    );
  }

  return (
    <div className={s.wrap}>
      <header className={s.header}>
        <BotaoMenuMobile />
        <span className={s.marca}>{BRAND_MARCA_CURTA}</span>
        <span className={s.usuario}>{usuario?.nome}</span>
        {podeTrocarOrg && <SeletorOrganizacao variant="header" />}
        <button className={s.sair} onClick={logout}>Sair</button>
      </header>
      <div className={s.conteudo}>
        <Relatorios />
      </div>
    </div>
  );
}
